/**
 * Fetches address details from India Post Pincode API
 * API: https://api.postalpincode.in/pincode/{pincode}
 * @param {string} pincode - 6 digit Indian pincode
 * @returns {Promise<{state: string, district: string, addressSuggestions: Array}>}
 */
export const fetchPincodeDetails = async (pincode) => {
  if (!pincode || String(pincode).length !== 6) {
    return null;
  }
  try {
    const response = await fetch(
      `https://api.postalpincode.in/pincode/${String(pincode).trim()}`
    );
    const data = await response.json();

    if (!data || !Array.isArray(data) || data.length === 0) {
      return null;
    }

    const first = data[0];
    if (first.Status !== 'Success' || !first.PostOffice || first.PostOffice.length === 0) {
      return null;
    }

    const firstOffice = first.PostOffice[0];
    const addressSuggestions = first.PostOffice.map((po) => ({
      label: `${po.Name}${po.Block ? `, ${po.Block}` : ''}, ${po.District}, ${po.State}`,
      value: `${po.Name}${po.Block ? `, ${po.Block}` : ''}, ${po.District}, ${po.State}`,
      ...po,
    }));

    return {
      state: firstOffice.State,
      district: firstOffice.District,
      division: firstOffice.Division,
      block: firstOffice.Block,
      region: firstOffice.Region,
      addressSuggestions,
      postOffices: first.PostOffice,
    };
  } catch (error) {
    console.error('Pincode lookup failed:', error);
    return null;
  }
};
